import { render, staticRenderFns } from "./LogGeral.vue?vue&type=template&id=7807cfb1&"
import script from "./LogGeral.vue?vue&type=script&lang=js&"
export * from "./LogGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports